<div class="route-component">
    <div class="search-component">
        <h4>
            Exchange Rates
        </h4>

        <div class="line-connector"></div>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button *hasPermission="['ExchangeRate', 'Create']" (click)="addExchangeRate()">
                        Add <i class="fas fa-plus"></i>
                    </button>
                    <button *hasPermission="['ExchangeRate', 'Export']" (click)="downloadExchangeRates(paging)">
                        Download <i class="fas fa-download"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="search-bar">
            <div class="search-bar left">
                <div class="search-container">

                    <auto-complete-dropdown
                        *ngIf="selectedPeriodId"
                        [type]="'period'"
                        [options]="periods"
                        [placeholder]="'Select a period...'"
                        [initialValue]="selectedPeriodId"
                        [displayWith]="formatPeriod"
                        (selectionChange)="onPeriodSelectionChange($event)">
                    </auto-complete-dropdown>

                </div>
            </div>
        </div>

        <pageable-table
            [items]="exchangeRates"
            [paging]="paging"
            [columns]="getColumnMap()"
            (refreshData)="getExchangeRates($event)"
            [showEdit]="showEdit || false"
            (editItem)="editExchangeRate($event)"
            [showCopy]="showCopy || false"
            (copyItem)="copyExchangeRate($event)"
            [showDelete]="showDelete || false"
            (deleteItem)="deleteExchangeRate($event)">
        </pageable-table>
    </div>
</div>